<template>
  <div>
    <div class="bg-soft bg-header-pattern py-10 md:py-12 lg:py-16">
      <div class="container mx-auto xl:px-8 px-4">
        <PartialsToolsNavigation
          :tools="tools"
          :current_tool="toolLocale.tool"
        />
      </div>
      <WidgetTool/>
    </div>
    <PartialsQrCodeContent />
    <LayoutsFaqTemplate :topic="toolLocale.tool.h1" :questions="questions" />
   
    <PartialsFreeTestimal />
    <PartialsTrackQrWidget />
    <PartialsFunctionalComponent />
    <PartialsBenifitWidget></PartialsBenifitWidget>
    <partials-reviewer-widget />
    <PartialsDialogGroup/>
    <homepage-agency-section />
  </div>
</template>
<script lang="ts" setup>
import moment from "moment";
import WidgetTool from "~~/components/tools/WidgetTool.vue";
import ToolLocale from "~~/config/widgets/tools-widget";
import { useQrCreateStore } from "~~/stores/qrcreate";
const toolLocale = new ToolLocale();
const tools = toolLocale.data;
const questions = toolLocale.questions;
const datajd = useDataJd();
const meta = useMeta();
const meta_tags = meta.metaTag({
  title: toolLocale.tool.title,
  description: toolLocale.tool.description,
  url: datajd.currentURL(),
  image: datajd.assets("/images/og/homepage.jpg"),
});
const i18nHead = useLocaleHead({
  addSeoAttributes: {
    canonicalQueries: ["/"],
  },
});
useHead({
  title: toolLocale.tool.title,
  meta: [
    { name: "description", content: toolLocale.tool.description },
    { name: "keywords", content: toolLocale.tool.keys },
    ...(i18nHead.value.meta || []),
    ...meta_tags,
  ],
  htmlAttrs: {
    lang: i18nHead.value.htmlAttrs!.lang,
  },
  link: [...(i18nHead.value.link || [])],
});
declare type questionsSchema = Array<any>;
var questionsSchema: questionsSchema = [];
questions.forEach((item) => {
  questionsSchema.push(
    defineQuestion({
      name: item.question,
      acceptedAnswer: item.answer,
      inLanguage: useI18n().localeProperties.value.iso,
    })
  );
});
useSchemaOrg([
  defineWebPage({
    name: toolLocale.tool.title,
    datePublished: moment("2023-05-03").toISOString(),
    dateModified: moment().toISOString(),
    description: toolLocale.tool.description,
    inLanguage: datajd.inLanguages(true),
    url: datajd.currentURL(),
    image: datajd.assets("/images/og/homepage.jpg"),
    "@type": "FAQPage",
  }),
  defineBreadcrumb({
    itemListElement: [
      {
        item: {
          "@id": datajd.currentHost(),
          name: "Home",
        },
      },
    ],
  }),
  ...questionsSchema,
]);

const qrstyle = useQrStyle();
const qrcreate = useQrCreateStore();
onMounted(() => {
  nextTick(() => {
    qrstyle.SetConfigStorage();
    if (!qrcreate.preload_font) {
      qrstyle.ImportFont();
    }
  });
});
</script>
